;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

export default function SectionHeader({ text, paddingTopLarge = false }) {
  return (
    <h2
      className={`font-bebas text-[30px] tracking-[.9px] leading-[150%] text-black mb-[20px] ${
        paddingTopLarge
          ? "mt-[40px] min-[800px]:mt-[50px] min-[1100px]:mt-[60px]"
          : "mt-[30px]"
      }`}
    >
      {text}
    </h2>
  )
}
